<div class="container-fluid min-vh-100 d-flex align-items-center justify-content-center py-5">
  <div class="row w-100 justify-content-center">
    <div class="col-12 col-sm-10 col-md-8 col-lg-6 col-xl-5">
      <div class="card register-card shadow-lg border-0">
        <div class="card-body p-4 p-md-5">
          <!-- Header Section -->
          <div class="text-center mb-4">
            <div class="register-icon mb-3">
              <i class="fa fa-user-plus fa-3x text-primary"></i>
            </div>
            <h2 class="card-title fw-bold mb-2">{{ 'REGISTER.TITLE' | translate }}</h2>
            <p class="text-muted mb-0">{{ 'REGISTER.SUBTITLE' | translate }}</p>
          </div>

          <!-- Loading State -->
          <div *ngIf="isCheckingRestriction" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Checking registration status...</span>
            </div>
            <p class="mt-2 text-muted">Checking registration availability...</p>
          </div>

          <!-- Registration Disabled Notice -->
          <div *ngIf="!isCheckingRestriction && isRegistrationRestricted" class="alert alert-warning text-center mb-4">
            <i class="fa fa-lock fa-2x mb-3 text-warning"></i>
            <h5 class="mb-2">Registration Currently Disabled</h5>
            <p class="mb-3">New user registration has been temporarily disabled by the administrator.</p>
            <a routerLink="/login" class="btn btn-primary" [attr.aria-label]="'NAV.LOGIN' | translate">
              <i class="fa fa-sign-in-alt me-2"></i>{{ 'NAV.LOGIN' | translate }}
            </a>
          </div>

          <form [formGroup]="registerForm" (ngSubmit)="register()" novalidate *ngIf="!isCheckingRestriction && !isRegistrationRestricted">"

            <!-- Personal Information -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="firstname" class="form-label">
                  <i class="fa fa-user me-2 text-muted"></i>{{ 'REGISTER.FIRST_NAME_LABEL' | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-user text-muted"></i>
                  </span>
                  <input
                    formControlName="firstname"
                    type="text"
                    class="form-control border-start-0"
                    [class.is-invalid]="registerForm.get('firstname')?.errors && registerForm.get('firstname')?.touched"
                    id="firstname"
                    [placeholder]="'REGISTER.FIRST_NAME_PLACEHOLDER' | translate"
                    autocomplete="given-name"
                  />
                  <div class="invalid-feedback" *ngIf="registerForm.get('firstname')?.touched && registerForm.get('firstname')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.FIRST_NAME_REQUIRED' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="lastname" class="form-label">
                  <i class="fa fa-user me-2 text-muted"></i>{{ 'REGISTER.LAST_NAME_LABEL' | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-user text-muted"></i>
                  </span>
                  <input
                    formControlName="lastname"
                    type="text"
                    class="form-control border-start-0"
                    [class.is-invalid]="registerForm.get('lastname')?.errors && registerForm.get('lastname')?.touched"
                    id="lastname"
                    [placeholder]="'REGISTER.LAST_NAME_PLACEHOLDER' | translate"
                    autocomplete="family-name"
                  />
                  <div class="invalid-feedback" *ngIf="registerForm.get('lastname')?.touched && registerForm.get('lastname')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.LAST_NAME_REQUIRED' | translate }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="mb-3">
              <label for="email" class="form-label">
                <i class="fa fa-envelope me-2 text-muted"></i>{{ 'REGISTER.EMAIL_LABEL' | translate }}
              </label>
              <div class="input-group">
                <span class="input-group-text border-end-0 bg-light">
                  <i class="fa fa-envelope text-muted"></i>
                </span>
                <input
                  formControlName="email"
                  type="email"
                  class="form-control border-start-0"
                  [class.is-invalid]="registerForm.get('email')?.errors && registerForm.get('email')?.touched"
                  id="email"
                  [placeholder]="'REGISTER.EMAIL_PLACEHOLDER' | translate"
                  autocomplete="email"
                />
                <div class="invalid-feedback" *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.hasError('required')">
                  <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.EMAIL_REQUIRED' | translate }}
                </div>
                <div class="invalid-feedback" *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.hasError('pattern') && !registerForm.get('email')?.hasError('required')">
                  <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.EMAIL_INVALID' | translate }}
                </div>
              </div>
            </div>

            <!-- Location Information -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="countryId" class="form-label">
                  <i class="fa fa-globe me-2 text-muted"></i>{{ 'REGISTER.COUNTRY_LABEL' | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-globe text-muted"></i>
                  </span>
                  <select
                    formControlName="countryId"
                    class="form-select border-start-0"
                    [class.is-invalid]="registerForm.get('countryId')?.errors && registerForm.get('countryId')?.touched"
                    id="countryId"
                  >
                    <option value="" disabled selected hidden>
                      {{ 'REGISTER.COUNTRY_PLACEHOLDER' | translate }}
                    </option>
                    <option *ngFor="let item of countries" [ngValue]="item.id">
                      {{ item.name }}
                    </option>
                  </select>
                  <div class="invalid-feedback" *ngIf="registerForm.get('countryId')?.touched && registerForm.get('countryId')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.COUNTRY_REQUIRED' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="state" class="form-label">
                  <i class="fa fa-map-marker me-2 text-muted"></i>{{ 'REGISTER.STATE_LABEL' | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-map-marker text-muted"></i>
                  </span>
                  <!-- US State Dropdown -->
                  <select
                    *ngIf="isUSSelected"
                    formControlName="state"
                    class="form-select border-start-0"
                    [class.is-invalid]="registerForm.get('state')?.errors && registerForm.get('state')?.touched"
                    id="state"
                  >
                    <option value="" disabled selected hidden>
                      {{ 'REGISTER.STATE_PLACEHOLDER' | translate }}
                    </option>
                    <option *ngFor="let state of states" [value]="state.code">
                      {{ state.name }}
                    </option>
                  </select>
                  <!-- Non-US State Text Input -->
                  <input
                    *ngIf="!isUSSelected"
                    formControlName="state"
                    type="text"
                    class="form-control border-start-0"
                    [class.is-invalid]="registerForm.get('state')?.errors && registerForm.get('state')?.touched"
                    id="state"
                    [placeholder]="'REGISTER.STATE_PLACEHOLDER' | translate"
                    autocomplete="address-level1"
                  />
                  <div class="invalid-feedback" *ngIf="registerForm.get('state')?.touched && registerForm.get('state')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.STATE_REQUIRED' | translate }}
                  </div>
                </div>
              </div>
            </div>

            <!-- City -->
            <div class="mb-3">
              <label for="city" class="form-label">
                <i class="fa fa-building me-2 text-muted"></i>{{ 'REGISTER.CITY_LABEL' | translate }}
              </label>
              <div class="input-group">
                <span class="input-group-text border-end-0 bg-light">
                  <i class="fa fa-building text-muted"></i>
                </span>
                <input
                  formControlName="city"
                  type="text"
                  class="form-control border-start-0"
                  [class.is-invalid]="registerForm.get('city')?.errors && registerForm.get('city')?.touched"
                  id="city"
                  [placeholder]="'REGISTER.CITY_PLACEHOLDER' | translate"
                  autocomplete="address-level2"
                />
                <div class="invalid-feedback" *ngIf="registerForm.get('city')?.touched && registerForm.get('city')?.hasError('required')">
                  <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.CITY_REQUIRED' | translate }}
                </div>
              </div>
            </div>

            <!-- Password Section -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="newPassword" class="form-label">
                  <i class="fa fa-lock me-2 text-muted"></i>{{ 'REGISTER.PASSWORD_LABEL' | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-lock text-muted"></i>
                  </span>
                  <input
                    formControlName="password"
                    [type]="showPassword ? 'text' : 'password'" 
                    class="form-control border-start-0"
                    [class.is-invalid]="registerForm.get('password')?.errors && registerForm.get('password')?.touched"
                    id="newPassword"
                    [placeholder]="'REGISTER.PASSWORD_PLACEHOLDER' | translate"
                    autocomplete="new-password"
                  />
                  <span class="input-group-text bg-light border-start-0" style="cursor:pointer;" (click)="showPassword = !showPassword">
                    <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </span>
                  <div class="invalid-feedback" *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.PASSWORD_REQUIRED' | translate }}
                  </div>
                  <div class="invalid-feedback" *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.hasError('minlength')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.PASSWORD_MIN_LENGTH' | translate }}
                  </div>
                  <div class="invalid-feedback" *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.hasError('maxlength')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.PASSWORD_MAX_LENGTH' | translate }}
                  </div>
                  <div class="invalid-feedback" *ngIf="registerForm.get('password')?.touched && (registerForm.get('password')?.hasError('pattern') || registerForm.get('password')?.hasError('mixedCase'))">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.PASSWORD_MIXED_CASE' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="confirmPassword" class="form-label">
                  <i class="fa fa-lock me-2 text-muted"></i>{{ 'REGISTER.CONFIRM_PASSWORD_LABEL' | translate }}
                </label>
                <div class="input-group">
                  <span class="input-group-text border-end-0 bg-light">
                    <i class="fa fa-lock text-muted"></i>
                  </span>
                  <input
                    matInput
                    formControlName="confirmPassword"
                    [type]="showConfirmPassword ? 'text' : 'password'" 
                    class="form-control border-start-0"
                    [class.is-invalid]="(registerForm.get('confirmPassword')?.errors && registerForm.get('confirmPassword')?.touched) || (registerForm.hasError('distinctPasswordsError') && registerForm.get('confirmPassword')?.touched)"
                    id="confirmPassword"
                    [placeholder]="'REGISTER.CONFIRM_PASSWORD_PLACEHOLDER' | translate"
                    autocomplete="new-password"
                  />
                  <span class="input-group-text bg-light border-start-0" style="cursor:pointer;" (click)="showConfirmPassword = !showConfirmPassword">
                    <i class="fa" [ngClass]="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                  </span>
                  <div class="invalid-feedback" *ngIf="registerForm.get('confirmPassword')?.touched && registerForm.get('confirmPassword')?.hasError('required')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.CONFIRM_PASSWORD_REQUIRED' | translate }}
                  </div>
                  <div class="invalid-feedback" *ngIf="registerForm.get('confirmPassword')?.touched && registerForm.hasError('distinctPasswordsError')">
                    <i class="fa fa-exclamation-circle me-1"></i>{{ 'REGISTER.PASSWORDS_MUST_MATCH' | translate }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Submit Button -->
            <div class="d-grid mb-4">
              <button
                type="submit"
                class="btn btn-primary btn-lg"
                [disabled]="!registerForm.valid"
              >
                <i class="fa fa-user-plus me-2"></i>{{ 'REGISTER.REGISTER_BUTTON' | translate }}
              </button>
            </div>

            <!-- Additional Links -->
            <div class="text-center">
              <div class="row">
                <div class="col-12 col-md-6 mb-2 mb-md-0">
                  <a [routerLink]="['/login-help']" class="btn btn-outline-secondary btn-sm w-100">
                    <i class="fa fa-key me-2"></i>{{ 'REGISTER.FORGOT_PASSWORD' | translate }}
                  </a>
                </div>
                <div class="col-12 col-md-6">
                  <a [routerLink]="['/contact-us']" class="btn btn-outline-info btn-sm w-100">
                    <i class="fa fa-question-circle me-2"></i>{{ 'REGISTER.NEED_HELP' | translate }}
                  </a>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>
